// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { MutableRefObject, useEffect, useRef, useState } from 'react';

// Observes the width of an element via ResizeObserver and returns the
// current pixel width (0 before first measurement). Used by the Gantt
// components to decide whether each bar is wide enough to fit its inline
// label without overflowing, and to pad the axis by MIN_BAR_WIDTH_PX
// worth of days at each end.
export function useObservedWidth(): [
  MutableRefObject<HTMLDivElement | null>,
  number,
] {
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (el === null) {
      return undefined;
    }
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      setWidth(entry.contentRect.width);
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, []);
  return [ref, width];
}
